import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/app/page.tsx");
